import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import Row from 'react-bootstrap/Row';
import bg1 from '../../assets/images/b2.png'


export default class Library extends Component {
    constructor(props) {
        super(props);
        this.state = {

        };
    }

    componentDidMount() {

    }

    render() {
        return (
            <div>
                <div className="pageHeader" style={{ backgroundImage: `url(${bg1})` }}>
                    <h1>Library</h1>
                </div>
                <h2>Library</h2>
                <p>See the amazing group of poets involved in this project, find out about their poems or see them all on a map. </p>
                <Row>
                    <NavLink className="button" activeStyle={this.style} to="/poets">Poets</NavLink>
                </Row>
                <br/>
                <Row>
                    <NavLink className="button" mactiveStyle={this.style} to="/poems">Poems</NavLink>
                </Row>
                <br/>
                <Row>
                    <NavLink  className="button" activeStyle={this.style} to="/poem-map">Poem Map</NavLink>
                </Row>
            </div>
        );
    }
}
